import { init as rellaxInit } from './rellax';
import { init as aosInit } from './aos';
import './portal-vue';

export default function init() {
    rellaxInit();
    aosInit();
}
